import React from 'react';
import { CTAPrimaryButton } from '../../../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import * as S from "./style";
import { Link } from 'react-router-dom';
import Routes from '../../../../routes/routes';
import StatisticsAnimation from '../../../../common/animation/animation-components/StatisticsAnimation';
import LazyLoad from 'react-lazyload';

const Statisctics = ({ trackPromoPageEvents, settings }) => {
  let ctaText = settings.trial_days ? `Try for free` : 'Subscribe Now';
  return (
    <S.ContainerWrapper>
      <S.OrangeCircle />
      <S.AquaCircle />
      <S.HeadingText>Gain math and reading confidence in just 2 months</S.HeadingText>
      <S.SubHeadingText>Children have shown a 77% improvement in their skills within the first 2 months of using SplashLearn</S.SubHeadingText>
      <S.AnimationWrapper >
        <LazyLoad once offset={50}>
          <StatisticsAnimation />
        </LazyLoad>
      </S.AnimationWrapper>
      <S.ButtonWrapper>
        <CTAPrimaryButton darkBlue={true}>
          <Link to={Routes.PURCHASE_ROUTE} onClick={() => trackPromoPageEvents("Promo Page Interacted", { 'clicked_on': 'CTA6' }, true)}>
            {ctaText}
          </Link>
        </CTAPrimaryButton>
      </S.ButtonWrapper>
    </S.ContainerWrapper>
  )
}

export default Statisctics;